import { ReactComponent as UilFlag } from "@/assets/icons/FlagOutlined.svg";
import { ReactComponent as RosaLogo } from "@/assets/icons/rosa-logo.svg";
import { ReactComponent as SummaryIcon } from "@/assets/icons/summary-icon.svg";

import * as Unicons from "@iconscout/react-unicons";
import { UilFile } from "@iconscout/react-unicons";
import clsx from "clsx";
import { useMemo } from "react";

type UniconProps = {
  name: string; // e.g., "UilUser", "UilEnvelope", etc.
  size?: string | number;
  color?: string;
  className?: string;
  onClick?: any;
};

const semanticColors: Record<string, string> = {
  primary: "var(--color-primary)",
  danger: "var(--color-error)",
  error: "var(--color-error)",
  info: "var(--color-info)",
  success: "var(--color-success)",
  warning: "var(--color-warning)",
  textColor: "var(--color-text)",
};

const customIcons = [
  {
    name: "SummaryIcon",
    icon: SummaryIcon,
  },
  {
    name: "UilFlag",
    icon: UilFlag,
  },
  {
    name: "RosaLogo",
    icon: RosaLogo,
  },
];

const IconGenerator = ({
  name,
  size = 24,
  color = "textColor",
  className,
  onClick,
}: UniconProps) => {
  const IconComponent = (Unicons as Record<string, React.ElementType>)[name];

  const appliedColor = semanticColors[color] || color;

  const icon = useMemo(() => {
    const customIcon = customIcons.find((x) => x.name === name);

    if (customIcon?.icon) {
      const { icon: Icon } = customIcon;

      return (
        <Icon
          width={size}
          height={size}
          color={appliedColor}
          fill={appliedColor}
          className={clsx(className)}
          onClick={onClick}
        />
      );
    }

    if (!IconComponent) {
      console.warn(`Unicon "${name}" not found.`);

      return (
        <UilFile
          size={size}
          color={appliedColor}
          className={clsx(className)}
          onClick={onClick}
        />
      );
    }

    return (
      <IconComponent
        size={size}
        color={appliedColor}
        className={clsx(className)}
        onClick={onClick}
      />
    );
  }, [IconComponent, size, appliedColor, className, onClick, name]);

  return icon;
};

export default IconGenerator;
